import api from '../axiosInstance'; 
import { APP_SETTINGS } from "../../../../config";
import { getFilteredQuery } from "app/assets/genericActions";
const getAuthHeaders = (token) => {
    if (!token) {
        console.error("Token is missing for API request.");
        return {};
    }
    return {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
    };
};


export const getAnnouncements = (filters, token) => {
    return api.get(`${APP_SETTINGS.API_PATH.ANNOUNCEMENTS.get}?${getFilteredQuery(
        filters
    )}`, getAuthHeaders(token));
};

export const getAnnouncementById = (id, token) => {
    return api.get(`${APP_SETTINGS.API_PATH.ANNOUNCEMENTS.getBYId}/${id}`, getAuthHeaders(token));
};

export const updateAnnouncement = (id, data, token) => {
    return api.patch(`${APP_SETTINGS.API_PATH.ANNOUNCEMENTS.update}/${id}`, data, getAuthHeaders(token));
};

export const deleteAnnouncement = (id, token) => {
    return api.delete(`${APP_SETTINGS.API_PATH.ANNOUNCEMENTS.delete}/${id}`, getAuthHeaders(token));
};

export const addAnnouncement = (data, token) => {
    return api.post(`${APP_SETTINGS.API_PATH.ANNOUNCEMENTS.add}`, data, getAuthHeaders(token));
};

export const getUserAnnouncements = (token) => {
    return api.get(`${APP_SETTINGS.API_PATH.ANNOUNCEMENTS.userAnnouncements}`, getAuthHeaders(token));
};

export const dismissUserAnnouncements = (id, token) => {
    return api.post(`${APP_SETTINGS.API_PATH.ANNOUNCEMENTS.dismissUserAnnouncements}/${id}`,{}, getAuthHeaders(token));
};